<template>
  <div>
     <van-popup v-model="showpop" mode="center" :close-on-click-overlay="false" :round="true">
      <div class="popup-content">
        <img src="@images/xxgk/close.png" class="close" @click="goClose" />
        <img src="@images/xxgk/dialog-top.png" style="width: 100%" mode="widthFix" />
        <div class="d-title">实名认证!</div>
        <div class="d-content">请您进行实名认证，认证后可查看认证的村/社区信息，快快行动起来吧！</div>
        <button class="d-button" @click="clickSmrzBtn">立即前往</button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk'
export default {
  props: {
    value:{
       type: Boolean,
       default:false,
    }
  
  },
  data() {
    return {
      showpop: false,
    }
  },
  watch: {
    value: {
      immediate: true,
      handler() {
        this.showpop = this.value
      },
    },
  },
  created() {},
  methods: {
    goClose(){
       this.$emit('input',false);
       this.$emit('close');
    },
		   clickSmrzBtn(){
        this.$emit('input',false);
        this.$nextTick(()=>{
            this.$router.push({
              name: 'smrz',
            });
        })
		  },
  
  },
}
</script>

<style lang="less">

.popup-content {
  width: 290px;
  height: 317px;
  position: relative;
}

.d-title {
  font-size: 16px;
  font-weight: 600;
  color: #3875f6;
  line-height: 25px;
  margin-top: 26px;
  text-align: center;
}

.d-content {
  font-size: 16px;
  font-weight: 500;
  color: #999999;
  line-height: 18px;
  margin: 16px 24px 32px;
  text-align: center;
}
.d-button {
  width: 80%;
  height: 38px;
  line-height: 38px;
  background: #3875f6;
  color: #ffffff;
  font-size: 16px;
  border-radius: 38px;
  margin-left: 10%;
  border: none;
}

.close {
  width: 24px;
  height: 24px;
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 1;
}

</style>
